export enum ConditionEvaluatorVersion {
  V1 = 'v1',
}
